import { TMarketIdentifiers } from '@/core/constants/event_types/base_mable_event';

type ShopifyCheckoutData = {
  checkoutSessionIdentifier: string;
  countryCode: string;
  customerProfileId: string;
  id: string;
  market?: {
    __typename: string;
    handle: string;
    id: string;
  };
  negotiationResult?: {
    buyerProposal?: {
      merchandiseDiscount?: {
        lines?: {
          sellingPlan?: string;
        }[];
      };
    };
    sellerProposal?: {
      buyerIdentity?: {
        customer?: {
          market?: {
            __typename: string;
            handle: string;
            id: string;
          };
        };
      };
    };
  };
  presentmentCurrency: string;
};

type UIData = ShopifyCheckoutData[][];

function getUIData(): UIData {
  const uiData = localStorage.getItem('__ui');
  return uiData ? JSON.parse(uiData) : [];
}

export function getCheckoutAndCartTokensFromUI(): {
  cartToken: string | null;
  checkoutToken: string | null;
} {
  const data = getUIData();
  return {
    cartToken: data[0]?.[0]?.id ?? null,
    checkoutToken: data[0]?.[0]?.checkoutSessionIdentifier ?? null,
  };
}

export function getSellingPlans(): string[] {
  const data = getUIData();
  const sellingPlans =
    data[0]?.[0]?.negotiationResult?.buyerProposal?.merchandiseDiscount?.lines
      ?.map(line => line.sellingPlan)
      .filter(Boolean) as string[];
  return sellingPlans ?? [];
}

export function getPresentmentCurrency(): string | null {
  const data = getUIData();
  return data[0]?.[0]?.presentmentCurrency ?? null;
}

export function getCountryCode(): string | null {
  const data = getUIData();
  return data[0]?.[0]?.countryCode ?? null;
}

export function getCustomerProfileId(): string | null {
  const data = getUIData();
  return data[0]?.[0]?.customerProfileId ?? null;
}

/**
 * Get the market data from the UI data
 * @returns The market data or null if not found
 */
export function getMarketDataFromUIObjectShopify(): TMarketIdentifiers | null {
  const data = getUIData();

  // Search through all elements to find market data in buyerIdentity
  for (const group of data) {
    for (const item of group) {
      const market =
        item?.negotiationResult?.sellerProposal?.buyerIdentity?.customer
          ?.market;
      const marketID = (market?.id ?? '').replace('gid://shopify/Market/', '');
      if (market) {
        return {
          do: '',
          is_captured: true,
          lo: '',
          mh: market?.handle ?? '',
          mid: marketID,
          re: '',
        };
      }
    }
  }

  return null;
}
